import { useMediaQuery } from 'react-responsive';

import { usePreviouslyPurchasedQuery } from 'api/queries/usePreviouslyPurchasedQuery';
import { BUY_IT_AGAIN_AISLE, MEMBER_DEALS_AISLE, SHOP_WITH_POINTS_AISLE, WEEKLY_PICKS_AISLE } from 'constants/shop';
import { AisleSubcategoryNavigationWrapper } from 'features/shop/navigation/AisleSubcategoryNavigation';
import Pill from 'honeydew/Pill';
import { useAccountPlusMembershipHook } from 'hooks/useAccountPlusMembershipHook';
import useTailwindTheme from 'hooks/useTailwindTheme';
import { trackAisleNavigation } from 'utils/analyticsUtils';

export function MobileL2PillNavigation() {
    const tailwindTheme = useTailwindTheme();
    const mobile = useMediaQuery({ maxWidth: tailwindTheme?.screens?.md });

    const { inPlusMembershipTreatment, plusMembershipBranding } = useAccountPlusMembershipHook();
    const { data: prevPurchasedData, isLoading: prevPurchasedIsLoading } = usePreviouslyPurchasedQuery();

    const prevPurchasedItems = prevPurchasedData?.items?.[0] ?? [];

    const showBuyItAgainAisle = !prevPurchasedIsLoading && prevPurchasedItems.length > 0;

    if (!mobile) return null;

    return (
        <AisleSubcategoryNavigationWrapper>
            <Pill
                as="navlink"
                to={WEEKLY_PICKS_AISLE.url}
                variant={window.location.pathname === WEEKLY_PICKS_AISLE.url ? 'active' : null}
                onClick={() =>
                    trackAisleNavigation({
                        aisleName: 'Weekly Picks',
                        level: 1,
                        mobile: true,
                        uiElement: 'mobile L1',
                    })
                }
            >
                {WEEKLY_PICKS_AISLE.name}
            </Pill>
            {showBuyItAgainAisle && (
                <Pill
                    as="navlink"
                    to={BUY_IT_AGAIN_AISLE.url}
                    variant={window.location.pathname === BUY_IT_AGAIN_AISLE.url ? 'active' : null}
                    onClick={() =>
                        trackAisleNavigation({
                            aisleName: BUY_IT_AGAIN_AISLE.name,
                            level: 1,
                            mobile: true,
                            uiElement: 'mobile L1',
                        })
                    }
                >
                    {BUY_IT_AGAIN_AISLE.name}
                </Pill>
            )}
            <Pill
                as="navlink"
                to={SHOP_WITH_POINTS_AISLE.url}
                variant={window.location.pathname === SHOP_WITH_POINTS_AISLE.url ? 'active' : null}
                onClick={() =>
                    trackAisleNavigation({
                        aisleName: SHOP_WITH_POINTS_AISLE.name,
                        level: 1,
                        mobile: true,
                        uiElement: 'mobile L1',
                    })
                }
            >
                {SHOP_WITH_POINTS_AISLE.name}
            </Pill>
            {inPlusMembershipTreatment && (
                <Pill
                    as="navlink"
                    to={MEMBER_DEALS_AISLE.url}
                    variant={window.location.pathname === MEMBER_DEALS_AISLE.url ? 'active' : null}
                    onClick={() =>
                        trackAisleNavigation({
                            aisleName: `${plusMembershipBranding} Deals`,
                            level: 1,
                            mobile: true,
                            uiElement: 'mobile L1',
                        })
                    }
                >
                    {`${plusMembershipBranding} Deals`}
                </Pill>
            )}
        </AisleSubcategoryNavigationWrapper>
    );
}
